import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

export const userResourcesColumns = [
    { field: 'viewedDatetime', name: 'Viewed Date ({tz} time zone)', dataType: 'datetime' },
    { field: 'resourceType', name: 'Type', dataType: 'multiselect' },
    {
        field: 'resourceTitle',
        name: 'Title',
        dataType: 'multiselect',
        styles: { minWidth: '30rem' },
    },
];

const UserResources = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [...userColumns, ...userResourcesColumns];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.viewedDatetime),
    //     {
    //         count: true,
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Views',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart
                    data={chartData}
                    chartTitle="Resource Views Over Time"
                />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows which resources (articles, videos, pages, etc) users
                    have accessed. Each row represents a single resource view by a user.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Viewed Date">
                    The date when the user accessed the resource.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Type">
                    The category or format of the resource.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Title">
                    The name or title of the specific resource that was viewed.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserResources;
